module.exports = __webpack_public_path__ + "static/media/60.f8a033a6.jpg";